import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-20abfdc4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "promotion"
};
const _hoisted_2 = {
  class: "user-income-expenses-filter-inner"
};
const _hoisted_3 = {
  class: "user-income-expenses-filter-value"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header flex"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, "时间"), /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, "明细")], -1));

const _hoisted_5 = {
  key: 0,
  class: "tbody"
};
const _hoisted_6 = {
  class: "item"
};
const _hoisted_7 = {
  class: "item"
};
const _hoisted_8 = {
  class: "details_page"
};
const _hoisted_9 = {
  key: 0,
  class: "head_title"
};
const _hoisted_10 = {
  class: "cont_body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_popover = _resolveComponent("van-popover");

  const _component_van_list = _resolveComponent("van-list");

  const _component_no_data = _resolveComponent("no-data");

  const _component_van_icon = _resolveComponent("van-icon");

  const _component_share_freeWatch = _resolveComponent("share-freeWatch");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", {
    class: "right_text",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.toDetails && $setup.toDetails(...args))
  }, "马上赚钱"), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "user-income-expenses-filter-key",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.search && $setup.search(...args))
  }, "筛选"), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_popover, {
    show: $setup.showPopover,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $setup.showPopover = $event),
    actions: $setup.actions,
    theme: "dark",
    placement: "bottom-end",
    onSelect: $setup.onSelect
  }, {
    reference: _withCtx(() => [_createTextVNode(_toDisplayString($setup.typeText), 1)]),
    _: 1
  }, 8, ["show", "actions", "onSelect"])])]), _hoisted_4, $setup.payLogList.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_van_list, {
    loading: $setup.loading,
    "onUpdate:loading": _cache[3] || (_cache[3] = $event => $setup.loading = $event),
    error: $setup.error,
    "onUpdate:error": _cache[4] || (_cache[4] = $event => $setup.error = $event),
    finished: $setup.finished,
    offset: 20,
    "error-text": "请求失败，点击重新加载",
    "finished-text": "-我也是有底线的-",
    "loading-text": "正在获取数据...",
    onLoad: $setup.onLoad
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.payLogList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "flex",
        key: index
      }, [_createElementVNode("div", _hoisted_6, _toDisplayString($setup.getMyDate(item.created)), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(item.remark), 1)]);
    }), 128))]),
    _: 1
  }, 8, ["loading", "error", "finished", "onLoad"])])) : (_openBlock(), _createBlock(_component_no_data, {
    key: 1,
    color: "#ffffff"
  })), _createVNode(_component_van_popup, {
    show: $setup.showDetailsPopul,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $setup.showDetailsPopul = $event),
    class: "popup_coentent",
    overlay: false,
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_ctx.showHeader ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_van_icon, {
      size: "22",
      name: "arrow-left",
      onClick: $setup.close
    }, null, 8, ["onClick"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_createVNode(_component_share_freeWatch, {
      onClose: $setup.close
    }, null, 8, ["onClose"])])])]),
    _: 1
  }, 8, ["show"])]);
}